import Model from "./abstract/Model";

export const CostDeterminationSelection = {
  INSURER: "INSURER",
  CUSTOMER: "CUSTOMER",
  LEASE_COMPANY: "LEASE_COMPANY"
};

export const COST_DETERMINATION_SELECTIONS = [
  CostDeterminationSelection.INSURER,
  CostDeterminationSelection.CUSTOMER,
  CostDeterminationSelection.LEASE_COMPANY
];

export const ContractCostDeterminationType = {
  CAR_PICK_UP: "CAR_PICK_UP",
  DEPLOYMENT_CHARGES: "DEPLOYMENT_CHARGES"
};

export default class ContractCostDetermination extends Model {
  cost_determination_id;
  contract_id;
  selection;

  constructor(props) {
    super();

    this.initializeAttributes(props, {});
  }
}
